import { render, staticRenderFns } from "./VideoBackground.vue?vue&type=template&id=8d1cc30a&scoped=true"
import script from "./VideoBackground.vue?vue&type=script&lang=js"
export * from "./VideoBackground.vue?vue&type=script&lang=js"
import style0 from "./VideoBackground.vue?vue&type=style&index=0&id=8d1cc30a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1cc30a",
  null
  
)

export default component.exports